import { useContext } from "react";

import { SettingsContext } from "../context/Settings/SettingsContext";

// feat_333 — Modo WAIAenvios: versión mínima de WAIA para clientes que SOLO
// disparan campañas por plantilla y atienden desde su teléfono. El panel queda
// podado a Conexiones + Carga de Datos (el reporte de campañas ya vive dentro
// de Carga de Datos, en BulkSendPanel).
//
// Gobernado por el setting de empresa `waiaEnviosMode` ("true"/"false"; ausente
// = false). Está en `publicKeys` de SettingController → lo lee TODO perfil, no
// solo el admin.
//
// ⚠ Un superadmin logueado en la empresa NO se ve afectado: necesita el panel
// completo para operar/diagnosticar.
//
// ⚠ Fuera del SettingsProvider (rutas de sesión: /login, /signup, /sala/...)
// el contexto cae a su valor por defecto y getSetting devuelve null → modo
// apagado. Es el comportamiento correcto: esas rutas no se podan.
export default function useWaiaEnviosMode(user) {
  const { getSetting } = useContext(SettingsContext);
  return getSetting("waiaEnviosMode") === "true" && !user?.isSuperAdmin;
}

// Únicas rutas privadas que resuelven en modo WAIAenvios. Los `path` son los
// que se registran en routes/index.js, tal cual (el gate compara por igualdad).
export const WAIA_ENVIOS_PATHS = ["/connections", "/carga-de-datos"];

// Destino de todo lo demás, incluidos "/" y "/dashboard" (hoy pages/Reports,
// que en este modo quedaría vacío).
export const WAIA_ENVIOS_HOME = "/carga-de-datos";
